module.exports = __webpack_public_path__ + "img/niño83.88a666d7.jpg";